<template>
  <div class="loading-screen" v-if="isPageLoading == true">
    <h2>Loading</h2>
    <div class="spinner-wrap">
      <md-progress-spinner :md-diameter="100" :md-stroke="10" md-mode="indeterminate"
        class="md-accent"></md-progress-spinner>
    </div>
  </div>

  <div class="jsa-screen" v-else>
    <div class="d-flex">
      <div class="button-block">
        <router-link :to="{ name: 'Project', params: { id: projectId } }" md-alignment="left" class="md-info">
          <md-button class="md-info">Go back to project</md-button>
        </router-link>
      </div>
      <div class="button-block">
        <md-button class="md-sm md-info export-button" @click="getPDF">VIEW PDF</md-button>
      </div>
      <div class="button-block">
        <md-button class="md-sm md-info export-button" @click="openAddUser">Email JSA</md-button>
      </div>
    </div>

    <div class="button-block p-actions-wrapper">
      <div class="addUser send-gpr-report" v-if="showAddUser">
        <md-field>
          <label>Email</label>
          <md-input v-model="newUser.email" type="text"></md-input>
        </md-field>
        <md-button class="md-success md-sm" :disabled="clickedOnce" @click="handleAddUser">Send JSA</md-button>
      </div>
    </div>

    <md-card class="md-layout-item md-size-100" v-if="currentCard === 1">
      <div class='jsa-container'>
        <div class='jsa-header'>
          <div>
            <span class="by_txt">Powered by</span>
            <img :src="logo" alt="" id='jsa_logo'>
          </div>
          <div class='company-logo'>
            <span class="by_txt">Prepared by</span>
            <div class="files-display-item" v-if="project.ats_company.files.length > 0">
              <img class="company_logo_2" :src="project.ats_company.files[0].url" />
            </div>
            <h2 v-if="project.ats_company.files.length == 0">{{ project.ats_company.name }}</h2>
          </div>
          <div class='company-name'>
            <h2>
              <span class='resource_info'>SafeCore Systems Job Safety Analysis(JSA) Form</span>
            </h2>
          </div>
        </div>

        <div class='jsa-content'>

          <!-- header one -->
          <div class='jsa-block-1 d-flex'>
            <span class='block-1-title'>1 . Hazards</span>
            <div class='d-flex jsa-blocks-1'>
              <div>
                <span>Date:</span><span class='info_jsa_1'> {{ project.ats_data.requested_start_date | formatDate
                  }}</span>
              </div>
              <div class='info_jsa_block'><span>Job:</span><span class='info_jsa_1'> {{ project.project.name }}</span>
              </div>
              <!-- <div class='info_jsa_block'><span>Site Contact</span><span class='info_jsa_1'>{{ project.site_contact.name
                  }}</span></div> -->
              <!-- <div class='info_jsa_block'><span>Initial X</span><span class='info_jsa_1'></span></div> -->
            </div>
          </div>

          <!-- block one -->
          <div class='d-flex gap-10'>

            <div class='jsa-block-left gap-10'>
              <div class='jsa-form-block'>
                <h3>CONCRETE CUTTING, CORING, & DEMO</h3>
                <div class='d-flex'>
                  <div>
                    <ul>
                      <li>Noise / Sound Slurry</li>
                      <li>Slip Hazard Vibration</li>
                      <li>Spark Hazard</li>
                      <li>Equipment Operation</li>
                      <li>Struck-By</li>
                      <li>Electrical Shock</li>
                      <li>Respiratory Hazards</li>
                      <li>Work Area Security</li>
                      <li>Large Diameter Holes</li>
                      <li>Helpers</li>
                      <li>PPE</li>
                      <li>Overhead Work</li>
                      <li>Other’s in work area (Public, Contractors)</li>
                      <li>Tools/Equipment</li>
                      <li>CO2 Ventilation</li>
                      <li>Other:</li>
                    </ul>
                  </div>
                  <div>
                    <ul class='form-right-ul'>
                      <li><input type="checkbox" v-model="formChecks.concrete[0]"></li>
                      <li><input type="checkbox" v-model="formChecks.concrete[1]"></li>
                      <li><input type="checkbox" v-model="formChecks.concrete[2]"></li>
                      <li><input type="checkbox" v-model="formChecks.concrete[3]"></li>
                      <li><input type="checkbox" v-model="formChecks.concrete[4]"></li>
                      <li><input type="checkbox" v-model="formChecks.concrete[5]"></li>
                      <li><input type="checkbox" v-model="formChecks.concrete[6]"></li>
                      <li><input type="checkbox" v-model="formChecks.concrete[7]"></li>
                      <li><input type="checkbox" v-model="formChecks.concrete[8]"></li>
                      <li><input type="checkbox" v-model="formChecks.concrete[9]"></li>
                      <li><input type="checkbox" v-model="formChecks.concrete[10]"></li>
                      <li><input type="checkbox" v-model="formChecks.concrete[11]"></li>
                      <li><input type="checkbox" v-model="formChecks.concrete[12]"></li>
                      <li><input type="checkbox" v-model="formChecks.concrete[13]"></li>
                      <li><input type="checkbox" v-model="formChecks.concrete[14]"></li>
                      <li><input type="input" v-model="formChecks.concrete[15]"></li>
                    </ul>
                  </div>
                </div>
                <p>GPR Required prior to sawing or drilling: Y<input type="checkbox" v-model="formChecks.concrete[16]">
                  /
                  N<input type="checkbox" v-model="formChecks.concrete[17]">
                </p>
              </div>
              <div class='jsa-form-block'>
                <h3>HIGHWAY / ROAD WORK</h3>
                <div class='d-flex'>
                  <div>
                    <ul>
                      <li>Traffic Hazard Control</li>
                      <li>Comment</li>
                      <li>Other:</li>
                    </ul>
                  </div>
                  <div>
                    <ul class='form-right-ul'>
                      <li><input type="checkbox" v-model="formChecks.highway[0]"></li>
                      <li><input type="input" v-model="formChecks.highway[1]"></li>
                      <li><input type="input" v-model="formChecks.highway[2]"></li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
            <div class='jsa-block-right gap-10 flex-1'>

              <div class='jsa-form-above d-flex  gap-10'>
                <div class='jsa-form-block' id='trenches'>
                  <h3>TRENCHES, EXCAVATIONS, MANHOLES, & SEWERS</h3>
                  <h4>(CONFINED SPACES)</h4>
                  <div class='d-flex'>
                    <div id='cave-in'>
                      <ul>
                        <li>Cave-In, Engulfment</li>
                        <li>Atmosphere (O2, Toxic, Flammable) </li>
                        <li>Access / Egress</li>
                        <li>Safe Work Procedures</li>
                        <li>Underground Utilities (gas, elec., Fiber optic, phone, water)
                          Falling Materials</li>
                        <li>Other</li>
                        <li>Comments</li>
                      </ul>
                    </div>

                    <div>
                      <ul class='form-right-ul'>
                        <li><input type="checkbox" v-model="formChecks.trenches[0]"></li>
                        <li><input type="checkbox" v-model="formChecks.trenches[1]"></li>
                        <li><input type="checkbox" v-model="formChecks.trenches[2]"></li>
                        <li><input type="checkbox" v-model="formChecks.trenches[3]"></li>
                        <li><input type="checkbox" v-model="formChecks.trenches[4]"></li>
                        <li><input type="input" v-model="formChecks.trenches[5]"></li>
                        <li><input type="input" v-model="formChecks.trenches[6]"></li>
                      </ul>
                    </div>
                  </div>

                </div>
                <div class='jsa-form-block'>
                  <h3>ELEVATED WORK & WORKING SURFACES</h3>
                  <h4>(Open floors/Floor levels, Scaffolds,<br> JLG, Scissors Lift, and Walking Surfaces)</h4>
                  <div class='d-flex'>
                    <div>
                      <ul>
                        <li>Uneven Surfaces</li>
                        <li>Fall Protection</li>
                        <li>Work Platform</li>
                        <li>Access / Egress Stability</li>
                        <li>Securely Attached</li>
                        <li>Anchorage Points</li>
                        <li>Other</li>
                      </ul>
                    </div>
                    <div>
                      <ul class='form-right-ul'>
                        <li><input type="checkbox" v-model="formChecks.elevated[0]"></li>
                        <li><input type="checkbox" v-model="formChecks.elevated[1]"></li>
                        <li><input type="checkbox" v-model="formChecks.elevated[2]"></li>
                        <li><input type="checkbox" v-model="formChecks.elevated[3]"></li>
                        <li><input type="checkbox" v-model="formChecks.elevated[4]"></li>
                        <li><input type="checkbox" v-model="formChecks.elevated[5]"></li>
                        <li><input type="input" v-model="formChecks.elevated[6]"></li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
              <div class='jsa-form-bottom d-flex gap-10'>
                <div class='jsa-form-block'>
                  <h3>HUMAN FACTORS</h3>
                  <div class='d-flex'>
                    <div>
                      <ul>
                        <li>Fatigue</li>
                        <li>Heat Stress/Cold</li>
                        <li>Illness</li>
                        <li>Rush / Emergency work</li>
                        <li>Poor Housekeeping</li>
                        <li>Material Handling (Safe Lifting)</li>
                      </ul>
                    </div>
                    <div>
                      <ul class='form-right-ul'>
                        <li><input type="checkbox" v-model="formChecks.human[0]"></li>
                        <li><input type="checkbox" v-model="formChecks.human[1]"></li>
                        <li><input type="checkbox" v-model="formChecks.human[2]"></li>
                        <li><input type="checkbox" v-model="formChecks.human[3]"></li>
                        <li><input type="checkbox" v-model="formChecks.human[4]"></li>
                        <li><input type="checkbox" v-model="formChecks.human[5]"></li>
                      </ul>
                    </div>
                  </div>
                </div>
                <div class='jsa-form-block flex-1'>
                  <h3>GPR Scanning Safety</h3>
                  <div class='d-flex'>
                    <div>
                      <ul>
                        <li>SafeCore Stencils & Ink</li>
                        <li>SafeCore Marking Tape</li>
                        <li>Other Methods: Crayons, Markers, Grease Pencils, Etc</li>
                      </ul>
                    </div>
                    <div>
                      <ul class='form-right-ul'>
                        <li><input type="checkbox" v-model="formChecks.other[0]"></li>
                        <li><input type="checkbox" v-model="formChecks.other[1]"></li>
                        <li><input type="checkbox" v-model="formChecks.other[2]"></li>
                      </ul>
                    </div>
                  </div>
                  <p>Known embedded Infrastructure to avoid: GPR Detect:
                  </p>
                  <p>PT Cables: Y<input type="checkbox" v-model="formChecks.other[3]"> / N<input type="checkbox"
                      v-model="formChecks.other[4]"> Conduits in Slab: Y<input type="checkbox"
                      v-model="formChecks.other[5]"> / N <input type="checkbox" v-model="formChecks.other[6]"></p>
                  <p>Avoid Rebar: Y<input type="checkbox" v-model="formChecks.other[7]"> / N<input type="checkbox"
                      v-model="formChecks.other[8]"> Steel Beams: Y<input type="checkbox" v-model="formChecks.other[9]">
                    /
                    N<input type="checkbox" v-model="formChecks.other[10]">
                  </p>
                  <p>Coring in bottom of pan decking prohibited: Y<input type="checkbox" v-model="formChecks.other[11]">
                    /
                    N<input type="checkbox" v-model="formChecks.other[12]"></p>
                </div>
              </div>

              <div>
                <div class='jsa-form-block'>
                  <h3>SafeCore Marking Options for Embedments & Tolerance Zones</h3>
                  <p>Mark Embedments: 1"(25mm) Wide:<input type="checkbox" v-model="formChecks.marking[0]">1.5"(38mm)
                    wide<input type="checkbox" v-model="formChecks.marking[1]"> 2"(50mm) wide:<input type="checkbox"
                      v-model="formChecks.marking[2]"></p>
                  <p>Mark Tolerance Zones: 4"(100mm) Wide:<input type="checkbox"
                      v-model="formChecks.marking[3]">5"(125mm)
                    wide<input type="checkbox" v-model="formChecks.marking[4]"> 6"(150mm) wide:<input type="checkbox"
                      v-model="formChecks.marking[5]"></p>
                  <p>Mark Slab on Grade Tolerance Zones: 12"(30cm) Wide:<input type="checkbox"
                      v-model="formChecks.marking[5]">18"(45cm) wide<input type="checkbox"
                      v-model="formChecks.marking[6]"> 24"(60cm) wide:<input type="checkbox"
                      v-model="formChecks.marking[7]"></p>
                </div>
              </div>

            </div>

          </div>

          <!-- block 2 header -->
          <div class='jsa-block-1 d-flex'>
            <span class='block-1-title'>2. ENGINEERING & ADMINISTRATIVE CONTROLS</span>
          </div>

          <!-- block 2 -->
          <div class='jsa-block-2 d-flex'>
            <div class='jsa-block-left gap-10'>

              <div class='d-flex gap-10'>
                <div class='row-1'>
                  <div class='jsa-form-block'>
                    <h3>PRECAUTIONS & PPE</h3>
                    <div class='d-flex'>
                      <div>
                        <ul>
                          <li>01 Visual Check</li>
                          <li>02 Uni-Strut Installation or Strapping</li>
                          <li>03 Core Catch/Proper Shoring</li>
                          <li>04 Vacuum Slurry / Water</li>
                          <li>05 Protective Covering</li>
                          <li>06 Double Anchor Large Diameter Holes</li>
                          <li>07 Equipment to set up and/or Dismantle Rig</li>
                          <li>08 Housekeeping – cores, tools, equip. Trash</li>
                          <li>09 Barricade area (security)</li>
                          <li>10 Area Watch / Security – Restricted Access</li>
                          <li>11 Hearing Protection</li>
                          <li>12 Proper Respirator / Supplied Air / Dust Mask</li>
                          <li>13 Safety Glasses with side protection</li>
                          <li>14 Mono-goggles / Face Shield</li>
                          <li>15 Gloves (appropriate for work)</li>
                          <li>16 Hard Hat</li>
                          <li>17 Di-Electric Boots</li>
                          <li>18 Steel Toed Work Boots</li>
                          <li>19 GFCI (Ground Fault Circuit Interrupter)</li>
                          <li>20 Water</li>
                          <li>21 Hot Work &/or other permits required</li>
                          <li>22 Protective Clothing / NOMEX, FRC, Other</li>
                          <li>23 Condition Inspected & Proper</li>
                        </ul>
                      </div>
                      <div>
                        <ul class='form-right-ul'>
                          <li><input type="checkbox" v-model="formChecks.precaution[0]"></li>
                          <li><input type="checkbox" v-model="formChecks.precaution[1]"></li>
                          <li><input type="checkbox" v-model="formChecks.precaution[2]"></li>
                          <li><input type="checkbox" v-model="formChecks.precaution[3]"></li>
                          <li><input type="checkbox" v-model="formChecks.precaution[4]"></li>
                          <li><input type="checkbox" v-model="formChecks.precaution[5]"></li>
                          <li><input type="checkbox" v-model="formChecks.precaution[6]"></li>
                          <li><input type="checkbox" v-model="formChecks.precaution[7]"></li>
                          <li><input type="checkbox" v-model="formChecks.precaution[8]"></li>
                          <li><input type="checkbox" v-model="formChecks.precaution[9]"></li>
                          <li><input type="checkbox" v-model="formChecks.precaution[10]"></li>
                          <li><input type="checkbox" v-model="formChecks.precaution[11]"></li>
                          <li><input type="checkbox" v-model="formChecks.precaution[12]"></li>
                          <li><input type="checkbox" v-model="formChecks.precaution[13]"></li>
                          <li><input type="checkbox" v-model="formChecks.precaution[14]"></li>
                          <li><input type="checkbox" v-model="formChecks.precaution[15]"></li>
                          <li><input type="checkbox" v-model="formChecks.precaution[16]"></li>
                          <li><input type="checkbox" v-model="formChecks.precaution[17]"></li>
                          <li><input type="checkbox" v-model="formChecks.precaution[18]"></li>
                          <li><input type="checkbox" v-model="formChecks.precaution[19]"></li>
                          <li><input type="checkbox" v-model="formChecks.precaution[20]"></li>
                          <li><input type="checkbox" v-model="formChecks.precaution[21]"></li>
                          <li><input type="checkbox" v-model="formChecks.precaution[22]"></li>
                        </ul>
                      </div>
                    </div>
                  </div>

                  <div class='jsa-form-block'>
                    <h3>OPERATOR - GENERAL</h3>
                    <div class='d-flex'>
                      <div>
                        <ul>
                          <li>24 Site Specific Training Received</li>
                          <li>25 Specialized Training required for this Job</li>
                          <li>26 Review of Jobsite for Unknown Hazards</li>
                          <li>27 Informed Contractor / Helper of OUR HAZARDS</li>
                          <li>28 Emergency Plan / Evacuation Location</li>
                          <li>29 Communications</li>
                          <li>30 Procedures</li>
                          <li>31 Other:</li>
                        </ul>
                      </div>
                      <div>
                        <ul class='form-right-ul'>
                          <li><input type="checkbox" v-model="formChecks.operator[0]"></li>
                          <li><input type="checkbox" v-model="formChecks.operator[1]"></li>
                          <li><input type="checkbox" v-model="formChecks.operator[2]"></li>
                          <li><input type="checkbox" v-model="formChecks.operator[3]"></li>
                          <li><input type="checkbox" v-model="formChecks.operator[4]"></li>
                          <li><input type="checkbox" v-model="formChecks.operator[5]"></li>
                          <li><input type="checkbox" v-model="formChecks.operator[6]"></li>
                          <li><input type="input" v-model="formChecks.operator[7]"></li>
                        </ul>
                      </div>
                    </div>
                  </div>

                </div>

                <div class='row-2 flex-1'>
                  <div class='jsa-form-block'>
                    <h3>TRENCHES, EXCAVATIONS,<br> MANHOLES, & SEWERS</h3>
                    <h4>(CONFINED SPACES)</h4>
                    <div class='d-flex'>
                      <div>
                        <ul>
                          <li>32 Sloping / Shoring / Shielding</li>
                          <li>33 Oxygen/LEL/Toxic Gases Check</li>
                          <li>34 Atmospheric Monitoring</li>
                          <li>35 Body Harness / Lifeline</li>
                          <li>36 Shielding system 18” above grade</li>
                          <li>37 No work below 2 feet below trench box.</li>
                          <li>38 Proper Ladder</li>
                          <li>39 Hole Watch / Attendant / Rescue</li>
                          <li>40 Entry Permit</li>
                          <li>41 Fire Watch / Fire Extinguisher</li>
                          <li>42 Restricted Access</li>
                          <li>43 Hot Work permits</li>
                          <li>44 Utilities Marked or Located</li>
                          <li>45 Bottle Watch (Supplied Air), Grade D</li>
                        </ul>
                      </div>
                      <ul class='form-right-ul'>
                        <li><input type="checkbox" v-model="formChecks.enTrenches[0]"></li>
                        <li><input type="checkbox" v-model="formChecks.enTrenches[1]"></li>
                        <li><input type="checkbox" v-model="formChecks.enTrenches[2]"></li>
                        <li><input type="checkbox" v-model="formChecks.enTrenches[3]"></li>
                        <li><input type="checkbox" v-model="formChecks.enTrenches[4]"></li>
                        <li><input type="checkbox" v-model="formChecks.enTrenches[5]"></li>
                        <li><input type="checkbox" v-model="formChecks.enTrenches[6]"></li>
                        <li><input type="checkbox" v-model="formChecks.enTrenches[7]"></li>
                        <li><input type="checkbox" v-model="formChecks.enTrenches[8]"></li>
                        <li><input type="checkbox" v-model="formChecks.enTrenches[9]"></li>
                        <li><input type="checkbox" v-model="formChecks.enTrenches[10]"></li>
                        <li><input type="checkbox" v-model="formChecks.enTrenches[11]"></li>
                        <li><input type="checkbox" v-model="formChecks.enTrenches[12]"></li>
                        <li><input type="checkbox" v-model="formChecks.enTrenches[13]"></li>
                      </ul>
                    </div>
                  </div>

                  <div class='jsa-form-block'>
                    <h3>HUMAN FACTORS</h3>
                    <div class='d-flex'>
                      <div>
                        <ul>
                          <li>46 Good / Proper Communications</li>
                          <li>47 Maintain Attention & Awareness</li>
                          <li>48 Rest / Water Breaks</li>
                          <li>49 Replenish Fluids / Vitamins / Minerals</li>
                          <li>50 Proper Housekeeping</li>
                          <li>51 Take time to do the job Safely</li>
                          <li>52 Expect the unexpected</li>
                          <li>53 Positive Hazard Intervention</li>
                          <li>54 Proper Conduct</li>
                          <li>55 Follow Safe Working Procedures</li>
                          <li>56 Emergency Procedures Understood</li>
                          <li>57 Emergency Action Plan</li>
                          <li>58 Safe Lifting Techniques-Use of Equipment</li>
                        </ul>
                      </div>

                      <div>
                        <ul class='form-right-ul'>
                          <li><input type="checkbox" v-model="formChecks.enHuman[0]"></li>
                          <li><input type="checkbox" v-model="formChecks.enHuman[1]"></li>
                          <li><input type="checkbox" v-model="formChecks.enHuman[2]"></li>
                          <li><input type="checkbox" v-model="formChecks.enHuman[3]"></li>
                          <li><input type="checkbox" v-model="formChecks.enHuman[4]"></li>
                          <li><input type="checkbox" v-model="formChecks.enHuman[5]"></li>
                          <li><input type="checkbox" v-model="formChecks.enHuman[6]"></li>
                          <li><input type="checkbox" v-model="formChecks.enHuman[7]"></li>
                          <li><input type="checkbox" v-model="formChecks.enHuman[8]"></li>
                          <li><input type="checkbox" v-model="formChecks.enHuman[9]"></li>
                          <li><input type="checkbox" v-model="formChecks.enHuman[10]"></li>
                          <li><input type="checkbox" v-model="formChecks.enHuman[11]"></li>
                          <li><input type="checkbox" v-model="formChecks.enHuman[12]"></li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div class='jsa-form-block responsibility-text'>
                <p>It is the operator’s responsibility to inform company of any potential hazards that may be present on
                  a
                  jobsite. Operator is instructed not to proceed until hazards have been satisfactorily remedied.</p>
              </div>

            </div>

            <div class='jsa-block-right gap-10'>
              <div class='jsa-form-block'>
                <h3>FALL PROTECTION & SCAFFOLDS</h3>
                <div class='d-flex'>
                  <div>
                    <ul>
                      <li>59 Proper ladder / secured</li>
                      <li>60 Body Harness / Lanyard</li>
                      <li>61 Lifeline</li>
                      <li>62 SRL (Self-Retracting Lifeline)</li>
                      <li>63 Handrail, mid-rail, toe-boards (if req’d.)</li>
                      <li>64 Mudsills, base plates, screw jacks <br>– Proper Cross Bracing.</li>
                      <li>65 Secured Height (4X min. base dimension)</li>
                      <li>66 Plumb & Level</li>
                      <li>67 Inspected</li>
                      <li>68 Properly Cross Braced</li>
                      <li>69 Proper Planking</li>
                      <li>70 Anchorage Points – 5,000 lbs./person</li>
                    </ul>
                  </div>

                  <div>
                    <ul class='form-right-ul'>
                      <li><input type="checkbox" v-model="formChecks.fall[0]"></li>
                      <li><input type="checkbox" v-model="formChecks.fall[1]"></li>
                      <li><input type="checkbox" v-model="formChecks.fall[2]"></li>
                      <li><input type="checkbox" v-model="formChecks.fall[3]"></li>
                      <li><input type="checkbox" v-model="formChecks.fall[4]"></li>
                      <li><input type="checkbox" v-model="formChecks.fall[5]"></li>
                      <li><input type="checkbox" v-model="formChecks.fall[6]"></li>
                      <li><input type="checkbox" v-model="formChecks.fall[7]"></li>
                      <li><input type="checkbox" v-model="formChecks.fall[8]"></li>
                      <li><input type="checkbox" v-model="formChecks.fall[9]"></li>
                      <li><input type="checkbox" v-model="formChecks.fall[10]"></li>
                      <li><input type="checkbox" v-model="formChecks.fall[11]"></li>
                    </ul>
                  </div>

                </div>
              </div>

              <div class='jsa-form-block'>
                <h3>EQUIPMENT OPERATION / JOB HAZARDS</h3>
                <div class='d-flex'>
                  <div>
                    <ul>
                      <li>71 Competent Person</li>
                      <li>72 Lockout / Tagout</li>
                      <li>73 Guards</li>
                      <li>74 Proper Grounding</li>
                      <li>75 Emergency Stand-by, Equip., First Aid</li>
                      <li>76 Inform contractor to cover holes<br> greater than 2” X 2”</li>
                      <li>77 Inform Helpers of Hazards and offer PPE</li>
                    </ul>
                  </div>

                  <div>
                    <ul class='form-right-ul'>
                      <li><input type="checkbox" v-model="formChecks.equitment[0]"></li>
                      <li><input type="checkbox" v-model="formChecks.equitment[1]"></li>
                      <li><input type="checkbox" v-model="formChecks.equitment[2]"></li>
                      <li><input type="checkbox" v-model="formChecks.equitment[3]"></li>
                      <li><input type="checkbox" v-model="formChecks.equitment[4]"></li>
                      <li><input type="checkbox" v-model="formChecks.equitment[5]"></li>
                      <li><input type="checkbox" v-model="formChecks.equitment[6]"></li>
                    </ul>
                  </div>

                </div>
              </div>

              <div class='jsa-form-block'>
                <h3>HIGHWAY / ROAD WORK</h3>
                <div class='d-flex'>
                  <div>
                    <ul>
                      <li>78 Proper placement of Signs – “Men Working<br> Ahead” or “lane closures”, etc.</li>
                      <li>79 Arrow Boards</li>
                      <li>80 Flagmen</li>
                      <li>81 Traffic Officers</li>
                      <li>82 High Visibility Personnel Vests</li>
                      <li>83 Flashing lights on Vehicles/Equipment</li>
                      <li>84 Barricades, Barrels, Panels, Cones & Tapers</li>
                    </ul>
                  </div>

                  <div>
                    <ul class='form-right-ul'>
                      <li><input type="checkbox" v-model="formChecks.enHight[0]"></li>
                      <li><input type="checkbox" v-model="formChecks.enHight[1]"></li>
                      <li><input type="checkbox" v-model="formChecks.enHight[2]"></li>
                      <li><input type="checkbox" v-model="formChecks.enHight[3]"></li>
                      <li><input type="checkbox" v-model="formChecks.enHight[4]"></li>
                      <li><input type="checkbox" v-model="formChecks.enHight[5]"></li>
                      <li><input type="checkbox" v-model="formChecks.enHight[6]"></li>
                    </ul>
                  </div>

                </div>
              </div>

            </div>

          </div>

          <!-- footer -->
          <div class='jsa-block-1 jsa-footer'>
            <div class='d-flex jsa-blocks-1'>
              <div class='info_jsa_block'><span>Prepared For:</span>
                <span class='info_jsa_1'>
                  <div class="title">
                    {{ project.ats_company.name }} <br />
                    {{ displayAddress(project.ats_company.address) }}
                  </div>
                </span>
              </div>

              <div class='info_jsa_block'><span>Prepared By:</span>
                <span class='info_jsa_1'>
                  <div class="title">
                    {{ project.gpr_report.user }}
                  </div>
                </span>
              </div>

            </div>

            <div class='d-flex jsa-blocks-1'>
              <div class='info_jsa_block'><span>Job location</span>
                <span class='info_jsa_1'>
                  <div class="title">{{ project.address.street_address }}</div>
                  <div class="title" v-if="project.address">
                    {{ project.address.city }}, {{ project.address.state }} {{ project.address.zip }}
                  </div>
                  <div class="title no-item" v-else>
                    No Address
                  </div>
                </span>
              </div>

              <div class='info_jsa_block'><span>Site Contact:</span>
                <span class='info_jsa_1'>
                  <div class="title">{{ project.site_contact.name }} <br /> {{ project.site_contact.phone }} <br />
                    {{ project.site_contact.email }}</div>
                </span>
              </div>

            </div>

            <div class='d-flex jsa-blocks-1'>
              <div class='info_jsa_block'><span>ATS Number:</span>
                <span class='info_jsa_1'>
                  <div class="title">
                    {{ project.ats_data.ats_number }}
                  </div>
                </span>
              </div>
              <div class='info_jsa_block'><span>Date:</span>
                <span class='info_jsa_1'>
                  {{ project.ats_data.requested_start_date | formatDate }}</span>
              </div>
            </div>
          </div>

        </div>

        <!-- upload images -->
        <!-- endupload images -->


        <!-- locations -->
        <div class="location-section md-card-content">
          <h2 class="md-layout-item md-size-100 md-medium-size-100 md-small-size-100 titles block-1-title">Locations
          </h2>
          <md-button class="md-info" v-on:click="nextCard(2)" :disabled="clickedOnce">Add Locations</md-button>
          <div v-for="(location, index) in savedLocations" :key="location.id"
            class="md-layout-item md-size-100 md-medium-size-100 md-small-size-100">
            <h3>ATS {{ project.ats_data.ats_number }} - Location {{ index + 1 }}</h3>
            <h6>Files</h6>
            <div class="files-display" v-if="location.files && location.files.length">
              <div class="files-display-item" v-for="(f) in location.files" :key="f.key">
                <div class="fdi-wrap">
                  <!-- <md-icon class="remove" v-on:click.native="removeFile(f, index)">close</md-icon> -->
                  <img class="fdi-img" :src="f.url" v-lazy="f.url" :srcset="f.url" />
                  <!-- <md-button class="md-sm md-info" v-on:click="openPic(f.url)">Open Image</md-button> -->
                  <md-button class="md-sm md-info" v-on:click="openLightbox(`${location.id}-${f.filename}`)">Open
                    Image</md-button>
                </div>
              </div>
            </div>
            <h6>Locations / Areas of work</h6>
            <p>{{ location.areaOfWork }}</p>
            <h6>Additional Observations / Safety Measures</h6>
            <p>{{ location.safetyMeasures }}</p>
            <br>
            <md-divider />
          </div>

          <!-- <LightBox :showLightBox="showbox" :media="images" :key="index" :startAt="startAt" /> -->

        </div>
        <!-- end locations -->

        <md-card-content class="start-inputs signature-inputs">
          <h2 class="md-layout-item md-size-100 md-medium-size-100 md-small-size-100 titles block-1-title">Terms of
            service</h2>
          <Limitation />
        </md-card-content>

        <JSASignature v-bind:request="request" v-bind:projectId="this.$route.params.id" v-on:goSign="goSignature" />

        <md-button class="md-info" v-on:click="submitForm">
          {{ jsa.form_checks ? 'Update JSA' : 'Submit JSA' }}
        </md-button>
      </div>
    </md-card>

    <md-card class="md-layout-item md-size-100" v-if="currentCard === 3">

      <md-card-header class="md-card-header-icon md-card-header-green">
        <div class="card-icon">
          <md-icon>settings_overscan</md-icon>
        </div>
        <h4 class="title">Job Safety Analysis(JSA): Scan Locations</h4>
      </md-card-header>

      <md-card-content>
        <div v-for="(location, index) in locations" :key="location.id">
          <div class="md-layout" v-if="currentLocation === index">
            <div class="md-layout-item md-size-100 report-header">
              <small>There are {{ locations.length }} locations for this
                project.</small>
            </div>
            <div class="md-layout-item md-size-100 report-section">
              <md-field>
                <label class="upload-image">Upload Images</label>
                <md-file v-model="location.imgPlaceholder" @md-change="getFiles($event, index)" multiple
                  accept="image/*" required />
              </md-field>
              <div class="files-display" v-if="location.files && location.files.length">
                <div class="files-display-item" v-for="f in location.files" :key="f.name">
                  <div class="fdi-wrap">
                    <md-icon class="remove" v-on:click.native="removeFile(f, index)">close</md-icon>
                    <img class="fdi-img" :src="f.url" />
                    <md-button class="md-sm md-info" v-on:click="openPic(f.url)">Open Image</md-button>
                  </div>
                </div>
              </div>
            </div>
            <div class="md-layout-item md-size-100 survey-section">

              <md-field class="other-notes summary-field">
                <label>Locations / Areas of work</label>
                <md-input v-model="location.areaOfWork" type="text"></md-input>
              </md-field>
              <md-field class="summary-field">
                <label>Additional Observations / Safety Measures</label>
                <md-input v-model="location.safetyMeasures" type="text"></md-input>
              </md-field>
            </div>

            <div class="location-actions">
              <md-progress-spinner v-if="isLocationSaving == true" md-mode="indeterminate" class="md-accent ats-spin"
                :md-diameter="30" :md-stroke="3"></md-progress-spinner>
              <md-button class="md-info" @click="changeLocation(index, 'prev')" v-if="index !== 0">Previous
                Location</md-button>
              <md-button class="md-info" @click="changeLocation(index, 'next')"
                v-if="index !== locations.length - 1">Next
                Location</md-button>
              <md-button class="md-info" @click="changeLocation(index, 'add')" v-if="index == locations.length - 1"
                :disabled="location.areaOfWork.length == 0 && filesToUpload.length == []">Save-Add
                Location</md-button>
            </div>
            <br />
            <div class="location-actions second-row">
              <md-button class="md-sm md-info" v-on:click="deleteLocation(location.id)">Delete Location</md-button>
              <md-button class="md-info" @click="changeLocation(index, 'save')" v-if="index == locations.length - 1"
                :disabled="location.areaOfWork.length == 0 && filesToUpload.length == []">Save
                Final Location</md-button>
            </div>
          </div>
        </div>
      </md-card-content>

      <md-card-actions md-alignment="right">
        <md-button class="md-info" v-on:click="prevCard(2)">Go Back</md-button>
        <md-button class="md-info" v-on:click="nextCard(3)" :disabled="locations.length == 0">Review/Finalize
          Locations</md-button>
      </md-card-actions>
    </md-card>

    <md-card class="md-layout-item md-size-100" v-if="currentCard == 4">
      <md-card-header class="md-card-header-icon md-card-header-green">
        <div class="card-icon">
          <md-icon>grading</md-icon>
        </div>
        <h4 class="title">Job Safety Analysis(JSA): Locations Review</h4>
      </md-card-header>
      <md-card-content class="md-layout">
        <div class="md-layout-item md-size-100">
          <div class="" v-for="(location, index) in savedLocations" :key="location.id">
            <h3>
              ATS {{ project.ats_data.ats_number }} - Location {{ index + 1 }}
            </h3>
            <h6>Files</h6>
            <div class="files-display" v-if="location.files && location.files.length">
              <div class="files-display-item" v-for="f in location.files" :key="f.name">
                <div class="fdi-wrap">
                  <!-- <md-icon class="remove" v-on:click.native="removeFile(f, index)">close</md-icon> -->
                  <img class="fdi-img" :src="f.url" />
                  <md-button class="md-sm md-info" v-on:click="openPic(f.url)">Open Image</md-button>
                </div>
              </div>
            </div>
            <h6>Locations / Areas of work</h6>
            <p>{{ location.areaOfWork }}</p>
            <h6>Additional Observations / Safety Measures</h6>
            <p>{{ location.safetyMeasures }}</p>
            <md-button class="md-sm md-info" v-on:click="deleteLocation(location.id)">Delete Location</md-button>
            <md-divider />
          </div>
        </div>



      </md-card-content>

      <md-card-actions md-alignment="right">
        <md-button class="md-info" v-on:click="prevCard(4)">Go Back</md-button>
        <md-button class="md-info" v-on:click="submitJSA">Submit</md-button>
      </md-card-actions>
    </md-card>

    <LightBox :showLightBox="showbox" :media="images" :key="index" :startAt="startAt" />
  </div>
</template>
<script>
// import {Collapse2} from '@/components'
import api from "@/api";
import idx from "idx";
import moment from 'moment';
import JSASignature from "@/pages/Dashboard/ProjectPages/Components/JSASignature.vue";
import Limitation from "@/pages/Dashboard/ProjectPages/Components/Limitation.vue";
import LightBox from 'vue-image-lightbox';
export default {
  components: {
    JSASignature,
    Limitation,
    LightBox
  },
  props: {
    logo: {
      type: String,
      default: "https://app.safecoresystems.com/img/mainscs_logo.png"
    },
  },
  data() {
    return {
      project: {},
      isLoading: false,
      isPageLoading: true,
      projectId: this.$route.params.id,
      formChecks: {
        concrete: Array(14).fill(false),
        highway: Array(1).fill(false),
        trenches: Array(5).fill(false),
        elevated: Array(6).fill(false),
        human: Array(6).fill(false),
        other: Array(4).fill(false),
        marking: Array(9).fill(false),
        precaution: Array(23).fill(false),
        operator: Array(7).fill(false),
        enTrenches: Array(13).fill(false),
        enHuman: Array(13).fill(false),
        fall: Array(12).fill(false),
        equitment: Array(7).fill(false),
        enHight: Array(7).fill(false),
      },
      additionalInfo: '',
      areaOfWork: '',
      request: {
        terms: false,
        signed_company_name: '',
        signed_user_name: '',
        customer_signature: '',
        gpr_techinician: ''
      },
      reference: '',
      showAddUser: false,
      clickedOnce: false,
      newUser: {
        email: '',
      },
      imgPlaceholder: [],
      jsa: {
        id: '',
        files: []
      },
      currentCard: 1,
      locations: [],
      savedLocations: [],
      isLocationSaving: false,
      currentLocation: 0,
      filesToUpload: [],
      canAdvance: false,
      locationHasErrors: false,
      images: [
        { // For image
          thumb: '',
          src: '',
          caption: '', // Optional
          srcset: '' // Optional for displaying responsive images
        },
      ],
      showbox: false,
      index: 0,
      startAt: 0,
    };
  },
  mounted() {
    var projectId = this.$route.params.id;
    if (projectId == undefined) {
      this.$router.push("projectportal");
    } else {
      api.getProject(projectId).then((response) => {
        // console.log('response', response)
        this.project = idx(response, (_) => _.data);
        this.isLoading = false;
        this.isPageLoading = false;
        this.request.signed_company_name = idx(response, _ => _.data.ats_company.name);
        this.request.signed_user_name = idx(response, _ => _.data.site_contact.name);
        this.request.gpr_techinician = idx(response, _ => _.data.ats_data.signed_user_name);

      });
      // if (this.project.jsa) {   
      api.getProjectForJSA(this.projectId).then((response) => {
        if (response.data && response.data.id) {
          if (response.data.form_checks) this.formChecks = idx(response, _ => _.data.form_checks)
          this.project = idx(response, (_) => _.data);
          this.additionalInfo = idx(response, _ => _.data.additional_info)
          this.areaOfWork = idx(response, _ => _.data.area_of_work)
          this.isLoading = false;
          this.isPageLoading = false;
          this.jsa = response.data
          this.request.customer_signature = idx(response, _ => _.data.customer_signature);
          if (idx(response, _ => _.data.customer_signature)) this.request.terms = true
          if (response.data.locations && response.data.locations.length > 0) {
            this.locations = response.data.locations;
            this.savedLocations = response.data.locations;
            var index = 0
            this.locations.forEach((location) => {
              location.files.forEach((file) => {
                const key = `${location.id}-${file.filename}`;
                file.srcset = file.url;
                file.src = file.url;
                file.thumb = file.url;
                file.id = key;
                index = index + 1;
                file.fileIndex = index;
                this.images.push(file)
              });
            })
            console.log('images', this.images)
          } else {
            this.addBlankLocation();
          }
        }
      })
      // }
    }
  },
  computed: {
  },
  methods: {
    submitForm() {
      const payload = {
        project_id: this.projectId,
        form_checks: this.formChecks,
        requested_start_date: this.project.ats_data.requested_start_date,
        job_name: this.project.ats_data.job_name,
        site_contact: this.project.site_contact.name,
        additional_info: this.additionalInfo,
        area_of_work: this.areaOfWork,
        operator: ''
      };

      api.createJsa(payload).then((response) => {
        this.jsa = response.data;
        this.notifyVue("JSA has been updated", "success");
      })
        .catch((error) => {
          this.notifyVue("something wrong", "error");
        });

    },
    goSignature(num) {
      console.log('goSignature', num)
    },
    notifyVue(message, color) {
      this.$notify({
        timeout: 2500,
        message: message,
        horizontalAlign: "left",
        verticalAlign: "top",
        type: color,
      });
    },
    displayAddress(address) {
      // console.log(address)
      // console.log(this.project.ats_data);
      for (const key in address) {
        if (address[key] == null) {
          address[key] = "";
        }
      }
      var full_ad =
        address.street_address +
        " " +
        address.address_line_2 +
        ", " +
        address.city +
        ", " +
        address.state +
        " " +
        address.zip_code;
      return full_ad;
      // return
    },
    getPDF() {
      if (this.jsa.form_checks) {
        this.isLoading = true;
        this.isPageLoading = true;
        api.getJSAPDFLink(this.projectId).then((response) => {
          //not sure if this will work in production
          var full_url = response.config.baseURL + response.config.url
          window.open(full_url, "_self");
        })
      } else {
        this.notifyVue("Please submit the JSA form", "error");
      }
    },
    openAddUser() {
      if (this.jsa.form_checks) {
        this.showAddUser = !this.showAddUser;
      } else {
        this.notifyVue("Please submit the JSA form", "error");
      }
    },
    handleAddUser() {
      console.log(this.newUser.email);
      this.clickedOnce = true;
      this.isLoading = true;
      if (this.newUser.email) {
        var data = {
          'email': this.newUser.email,
          'id': this.projectId
        }
        api.sendJSAPDFEmail(data).then((response) => {
          this.clickedOnce = false;
          this.isLoading = false;
          console.log(response);
          //not sure if this will work in production
          this.notifyVue(
            "Sent PDF link to " + this.newUser.email,
          );
        });
      }
    },
    getFiles(filesList, index) {
      // var formData = new FormData();
      // const file = filesList[0]
      // // filesList.forEach((file) => {
      // var reader = new FileReader();

      // formData.append("file[]", file);
      // api.addFileToJSA(this.jsa.id, formData).then(({ data }) => {
      //   this.jsa.files = data
      // });
      var formData = new FormData();
      var locationId = this.locations[index].id;
      /** If the location exists, use the existing 'addFiletoLocation'
       *  apply the return 'data' into 'this.locations' */
      if (locationId) {
        const file = filesList[0]
        // filesList.forEach((file) => {
        formData.append("file[]", file);
        // });
        api.addFileToJSALocation(locationId, formData).then(({ data }) => {
          const newLocations = this.locations.map((l) => ({ ...l }));
          newLocations[index].files = data;
          this.locations = newLocations;
        });
      } else {
        var ok = [];
        this.setFilesToUpload(filesList);
        this.locations[index].imgPlaceholder = "";
        for (let i = 0; i < filesList.length; i++) {
          let fileUrl = URL.createObjectURL(filesList[i]);
          let newFile = {
            url: fileUrl,
            filename: filesList[i].name,
          };
          ok.push(newFile);
        }
        const newLocations = this.locations.map((l) => ({ ...l }));
        newLocations[index].files = [...newLocations[index].files, ...ok];
        this.locations = newLocations;
        this.locations[index].imgPlaceholder = "";
      }
    },
    setFilesToUpload(filesList) {
      this.filesToUpload = [...this.filesToUpload, ...filesList];
    },
    openPic(url) {
      window.open(url, "_blank");
    },
    deleteFile(id) {
      if (confirm(`Are you sure you want to delete this file?`)) {
        api.deleteJsaFile(this.jsa.id, id).then((response) => {
          this.notifyVue(`You have deleted this file`)
          this.jsa.files = this.jsa.files.filter(
            (f) => f.id !== id
          );
        })
      }
    },
    nextCard(num) {
      let newCard = num + 1;
      this.currentCard = newCard;
      window.scrollTo(0, 0);
    },
    prevCard(num) {
      let newCard = num - 1;
      this.currentCard = newCard;
      window.scrollTo(0, 0);
    },
    async changeLocation(index, move) {
      let location = this.locations[index];
      this.isLocationSaving = true;
      try {
        if (this.locations[index].newL) {
          var passed = await this.createBELocation(this.locations[index], move);
          this.locations[index].newL = false;
        } else {
          var passed = await this.updateLocation(this.locations[index], move);
        }
      } catch (error) {
        console.log('error location error', error);
      }
      if (passed) {
        switch (move) {
          case "next":
            this.currentLocation = index + 1;
            console.log("done saving????");
            this.isLocationSaving = false;
            this.canAdvance = false;
            break;
          case "prev":
            this.currentLocation = index - 1;
            this.isLocationSaving = false;
            this.canAdvance = false;
            break;
          case "save":
            this.canAdvance = true;
            this.isLocationSaving = false;
            this.locations[index].status = "saved";
            break;
          case "add":
            this.showAllTasks = true;
            this.addBlankLocation();
            this.currentLocation = index + 1;
            this.isLocationSaving = false;
            this.canAdvance = true;
            this.isLocationSaving = false;
            this.locations[index].status = "saved";
            break;
        }
      }
    },
    updateLocation(location) {
      this.filesToUpload = [];
      var a = api
        .updateJSALocation({ location: location })
        .then((response) => {
          this.notifyVue("Location has been saved", "success");
          return true;
        })
        .catch((err) => {
          console.log(err);
          this.locationHasErrors = true;
          // this.locationErrors = err;
          return false;
        });
      return a;
    },
    createBELocation(location, move) {
      var formData = new FormData();
      formData.append("location", JSON.stringify(location));
      if (this.filesToUpload.length) {
        for (let i = 0; i < this.filesToUpload.length; i++) {
          formData.append("files[]", this.filesToUpload[i]);
        }
      }
      this.filesToUpload = [];
      var b = api
        .createJSALocation(formData)
        .then((response) => {
          this.notifyVue("Location has been created", "success");
          // var location = response.data.location;
          const newLocations = JSON.parse(JSON.stringify(this.locations));
          newLocations[newLocations.length - 1].id = response.data.location.id;
          // this.locations = newLocations;
          location.id = response.data.location.id;
          const existingLocation = this.savedLocations.find(loc => loc.id === location.id);
          // If location does not exist, add it to the array
          if (!existingLocation) {
            this.savedLocations.push(location);
          }
          return true;
        })
        .catch((err) => {
          console.log('API Error', err);
          this.locationHasErrors = true;
          this.isLocationSaving = false;
          return false;
        });
      return b;
    },
    addBlankLocation() {
      this.locations.push({
        files: [],
        imgPlaceholder: [],
        jsa_form_id: this.jsa.id,
        areaOfWork: "",
        safetyMeasures: "",
        newL: true,
        status: "draft",
      });

    },
    deleteLocation2(location_id) {
      // Use splice to remove the location at the given index
      if (confirm(`Are you sure you want to delete this location?`)) {
        if (this.locations.length == 1) {
          return this.notifyVue("Please add at least one location", "error");
        }
        if (location_id == undefined) {
          this.locations.pop();
        } else {
          this.locations = this.locations.filter(location => location.id !== location_id);
        }
        this.currentLocation = this.locations.length - 1;
        if (this.currentLocation < 0) {
          this.currentLocation = 0;
        }
      }
    },
    deleteLocation(location_id) {
      // Use splice to remove the location at the given index
      if (confirm(`Are you sure you want to delete this location?`)) {
        var data = {
          location_id: location_id,
        }
        api.deleteJSALocation(data).then((response) => {
          this.savedLocations = this.savedLocations.filter(location => location.id !== location_id);
          this.locations = this.locations.filter(location => location.id !== location_id);
        })
      }
    },
    submitJSA() {
      this.currentCard = 1;
      api.getProjectForJSA(this.projectId).then((response) => {
        if (response.data && response.data.id) {
          if (response.data.form_checks) this.formChecks = idx(response, _ => _.data.form_checks)
          this.additionalInfo = idx(response, _ => _.data.additional_info)
          this.areaOfWork = idx(response, _ => _.data.area_of_work)
          this.isLoading = false;
          this.isPageLoading = false;
          this.jsa = response.data
          this.request.customer_signature = idx(response, _ => _.data.customer_signature);
          if (idx(response, _ => _.data.customer_signature)) this.request.terms = true
          if (response.data.locations && response.data.locations.length > 0) {
            this.locations = response.data.locations;
            this.savedLocations = response.data.locations;
          } else {
            this.addBlankLocation();
          }
          console.log('this.jsa', this.jsa)
        }
      })
    },
    openLightbox(key) {
      console.log('key', key)
      const selectedImage = this.images.find(x => x.id === key);
      this.showbox = true;
      this.startAt = selectedImage.fileIndex
      this.index = selectedImage.fileIndex + 1
    },
  },
  filters: {
    formatDate: function (value) {
      if (value) {
        return moment(String(value)).format('MM/DD/YYYY')
      }
    }
  }
};
</script>
<style lang="scss">
.jsa-container {
  background: #fff;
  padding: 40px 40px;
  width: 1400px;
  margin: 20px auto;

  p {
    margin: 0px;
  }

  h2,
  h3 {
    margin: 0px;
    padding: 0px;
  }
}

#jsa_logo {
  width: 210px;
  height: 50px;
  margin-top: 5px;
  margin-right: 10px;
}

.jsa-header {
  display: flex;
  border-bottom: 4px solid #000;
  margin-bottom: 10px;
}

.company-logo {
  width: 35%;
  border-bottom: 2px solid #000;
  margin-right: 30px;
  height: 90px;
}

.company-name h2 {
  padding: 0px;
  margin: 0px;
  font-size: 26px;
  font-weight: bold;
}

.company-name {
  width: 45%;
}

.company-name ul {
  padding: 0px;
  list-style: none;
}

.info-block {
  margin-left: 20px;
  margin-top: 0px;
}

.info-block-1 {
  font-weight: bold;
  margin: 0px;
}

.resource_info {
  font-weight: normal;
}

.jsa-blocks-1 {
  flex: 1;
  gap: 10px;
  justify-content: space-between;
  margin-left: 10px
}

.block-1-title {
  font-size: 24px;
  font-weight: bold;
}

.info_jsa_block {
  flex: 1;
  display: flex;
}

.info_jsa_1 {
  border-bottom: 1px solid #000;
  flex: 1;
  text-align: center;
}

.jsa-form-block {
  border: 2px solid #000;
  padding: 10px 20px;
  margin-bottom: 10px;
}

.jsa-form-block ul {
  list-style: none;
  padding: 0px;
}

.form-right-ul li {
  width: 70px;
  border-bottom: 1px solid #000;
  height: 24px;
}

.jsa-block-1 {
  margin-bottom: 10px;
}

.jsa-form-block h3 {
  font-size: 18px;
  font-weight: bold;
  border-bottom: 2px solid #000;
  text-align: center;
}

.gap-10 {
  gap: 10px;
}

#trenches {
  width: 55%;
}

#cave-in {
  max-width: 70%;
}

.flex-1 {
  flex: 1;
}

.jsa-block-2 {
  gap: 10px;
  margin-bottom: 10px;
}

.jsa-block-2 .jsa-block-left {
  width: 68%;
}

.jsa-block-2 .jsa-block-right {
  flex: 1;
}

.jsa-footer .info_jsa_block {
  margin-top: 10px;
}

.jsa-footer span {
  font-weight: bold;
}

.responsibility-text {
  font-weight: bold;
}

.jsa-form-block h4 {
  font-size: 18px;
  font-weight: bold;
  text-align: center;
  margin: 5px 0px;
}

.form-right-ul input,
.info_jsa_1 input {
  width: 100%;
  border: none;
  text-align: center;
  color: #3c4858;
  font-weight: bold;
  font-size: 1rem;
}

.jsa-screen {
  overflow-x: scroll
}

.company_logo_2 {
  max-height: 60px;
  width: auto !important;
}

.files-display-item {
  text-align: center;
}

.by_txt {
  font-size: 14px;
  color: #407739;
}

.jsa-screen .md-info .md-ripple {
  padding: .40625rem 1.25rem !important;
  font-size: 11px;
}

.report-section {
  margin-top: 20px;
}

.location-section {
  padding: 50px 0px;
}
</style>
